<div class="lpr-source-partial-matches">
  <mat-slide-toggle
    class="lpr-source-partial-matches__toggle"
    data-testid="source-partial-matches-toggle"
    [ngModel]="arePartialMatchesShown"
    (ngModelChange)="onToggleChange($event)"
    [color]="'primary'"
    >{{ 'vehicleIntelligence.alprSearch.partialMatches.showPartialMatches' | t }}</mat-slide-toggle
  >
  <sn-icon
    class="lpr-source-partial-matches__info-icon"
    fontIcon="fa-circle-info"
    fontSet="fa-light"
    matTooltip="{{
      ('vehicleIntelligence.alprSearch.partialMatches.tooltipFirstLine' | t) +
        '\n\n' +
        ('vehicleIntelligence.alprSearch.partialMatches.tooltipSecondLine' | t)
    }}"
    [matTooltipPosition]="'below'"
    [matTooltipClass]="'lpr-source-partial-matches__tooltip'"
  ></sn-icon>
</div>
